/** Presentation only. Never use this to rename, persist, sign or compare records. */
export function formatInterfaceText(value: string): string {
  return value.replace(/(?<=\S)\u2014(?=\S)/g, ' - ').replace(/[\u2013\u2014]/g, '-');
}

/** Remove only a verified project prefix, not arbitrary parts of a room name. */
export function getDataRoomHeading(name: string, projectName?: string | null): string {
  const trimmed = name.trim();
  if (projectName && trimmed.startsWith(projectName.trim())) {
    const suffix = trimmed.slice(projectName.trim().length);
    const match = suffix.match(/^\s+[\u2013\u2014·-]\s+(.+)$/);
    if (match?.[1]) return formatInterfaceText(match[1]);
  }
  return formatInterfaceText(trimmed);
}
